module.exports = "/_next/static/images/Channel@2x-abc74ba627c5dc1e6996f063c81ccb22.webp";